<div class="Modal">
  <div class="HeaderModal">
    <div class="IconModal float-start">
      <span class="material-icons">
        {{data.icon}}
      </span>
      <p>{{data.textIcon}}</p>
    </div>
    <span class="material-icons float-end CloseModal" (click)="onNoClick()"> close </span>
  </div>
  <div class="ModalContent">
    <h1 class="TtlModal text-start">
      {{data.title}}
    </h1>
    <p class="TxtModal text-start">
      {{data.text}}
    </p>
  </div>
</div>
